import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';

import ProductServices from '../../../services/ProductServices';

const UpdateInventory = ({ item, show, handleClose, store, onSuccess }) => {
  console.log(item);

  // Initial form values including authorize quantity (qtyAuth) and critical stock quantity
  const initialFormValues = {
    partNo: item?.masterItem?.partNo || '',
    qtyAuth: item?.qtyAuth || 0,
    criticalStockQty: item?.criticalStockQty || 0,
  };

  const [formValues, setFormValues] = useState(initialFormValues);

  // Update state when item data changes
  useEffect(() => {
    setFormValues({
      partNo: item?.masterItem?.partNo || '',
      qtyAuth: item?.qtyAuth || 0,
      criticalStockQty: item?.criticalStockQty || 0,
    });
  }, [item]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
   
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Send both qtyAuth and criticalStockQty in the update payload
      await ProductServices.UpdateInventory(item._id, {
        qtyAuth: formValues.qtyAuth,
        criticalStockQty: formValues.criticalStockQty,
      });

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Inventory has been updated successfully!',
        timer: 2000,
        showConfirmButton: false,
      });

      setTimeout(() => {
        onSuccess(); // callback to refresh parent data
        handleClose(); // Close modal after successful update
      }, 2000);
      
    } catch (error) {
      Swal.fire('Error', 'Failed to update inventory', 'error');
    }
  };

  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>
            <i className="fas fa-edit"></i> Update Inventory
          </Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row className="mb-2">
              <Col md="6">
                <label>Part No</label>
                <input
                  type="number"
                  name="partNo"
                  className="form-control form-control-sm"
                  value={formValues.partNo}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Authorize Qty</label>
                <input
                  type="number"
                  name="qtyAuth"
                  className="form-control form-control-sm"
                  value={formValues.qtyAuth}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Critical Stock Qty</label>
                <input
                  type="number"
                  name="criticalStockQty"
                  className="form-control form-control-sm"
                  value={formValues.criticalStockQty}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save changes
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default UpdateInventory;
